import { Pipe, PipeTransform } from '@angular/core';
import { arrayOfMoreThanOne } from 'src/app/utils/array.utils';

@Pipe({
    name: 'arrayOfMoreThanOne',
    standalone: false
})
export class ArrayOfMoreThanOnePipe implements PipeTransform {
    transform(value: any[]): boolean {
        return arrayOfMoreThanOne(value);
    }
}
